import PropTypes from 'prop-types';
import React from 'react';

import { Flex } from '../grid';
import { Label, P, Subheading } from '../typography';

const RecipeIngredients = ({ recipeIngredients, servingSize }) => (
  <Flex py={1} px="1.5rem" bg="white" flexDirection="column" width="100%">
    <Subheading>Ingredients</Subheading>
    <Label color="greyPrimary" mt={1} mb="0.5rem">
      For {servingSize} {servingSize > 1 ? 'servings' : 'serving'}
    </Label>
    {recipeIngredients.map(({ quantity, ingredient }) => (
      <P mb="0.5rem" key={`${quantity}-${ingredient}`}>
        {quantity} {ingredient}
      </P>
    ))}
  </Flex>
);

RecipeIngredients.propTypes = {
  servingSize: PropTypes.number.isRequired,
  recipeIngredients: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.string,
      ingredient: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export { RecipeIngredients };
